<template>
  <div>
    <apexchart
      type="line"
      height="350"
      ref="chart"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>
<style scoped>
h1 {
  color: white;
  text-align: center;
}
</style>
<script>
import VueApexCharts from "vue-apexcharts";
import moment from "moment";

import { get } from "vuex-pathify";

export default {
  
  name: "vlivegraph",
  components: { apexchart: VueApexCharts },
  props: [ "subdata", "heading"],
  data() {
    return {
      chartAtn: [],
      chartdataIn: [],
      chartcategories: [],
      series: [
        {
          name: "Percentage",
          data: [],
          
        },
      ],
    }
  },
  computed: {
    apiUrl: get("app/apiUrl"),
      chartOptions: function() {
        const self = this;
      return {
        chart: {
          height: 350,
          type: "line",
        },
        stroke: {
          width: 7,
          curve: "smooth",
        },
        tooltip: {
          custom: function({ series, seriesIndex, dataPointIndex }) {
            
            return (
              "<table id='customers'><tr><td>Percentage : </td><td style='text-align: center;'><span>" +
              series[seriesIndex][dataPointIndex] +"% " +  self.chartAtn[dataPointIndex]+
              "</span>" +
              "</td></tr></table>"
            );
          },
        },        
        xaxis: {
          type: "datetime",
          categories: [],
          tickAmount: 5,
          labels: {
            formatter: function(value) {
              return moment(String(new Date(value))).format("DD-MMM");
            },
          },
        },
        title: {
          text: this.heading,
          align: "left",
          style: {
            fontSize: "16px",
            color: "#666",
          },
        },
        
        markers: {
          size: 4,
          colors: ["#FFA41B"],
          strokeColors: "#fff",
          strokeWidth: 2,
          hover: {
            size: 7,
          },
        },
        yaxis: {
          min: 0,
          max: 100,
          title: {
            text: "Percentage",
          },
                   
        },
      };
    
    },

  },
  watch: {
    subdata: function(value) {
      console.log(value);
      this.showData();
    },
  },
  mounted() {
    this.showData();
  },
  methods: {
    showData() {
      const self = this;
      //self.series = [];
      self.chartAtn = [];
      self.chartdataIn = [];
      self.chartcategories = [];
      self.subdata.forEach((element) => {
        self.chartdataIn.push(element.peR_OBTAINED);
        self.chartAtn.push(element.eaM_ATTEND_TYPE);
        
        
        self.chartcategories.push(element.eX_DT);
      });
      
      //self.series.push({name:"A", data: self.chartdataIn });
      self.$refs.chart.updateSeries([
        {
          data: self.chartdataIn,
          
        },
      ]);
      self.$refs.chart.updateOptions({
        xaxis: {
          categories: self.chartcategories,
        },
      });
    },
  },
};
</script>
